/**
 * 数科-臻有钱首页-右下角浮标 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-右下角浮标
 * uuid:c666c9797ff14377b2a20749963e863c
 */

import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import AdvCommonContainer from '../adv-common-container';
import style from './index.module.scss';

const HomeStore = namespace('home');

 @Component
export default class AdvHomeFloat extends Vue {
  @HomeStore.Action $updateState!: (data: Dictionary) => void;

  private onLoadHandler() {
    this.$updateState({
      advHomeFloatHasVisible: true,
    });
  }

  private render() {
    return (
      <AdvCommonContainer
        advMasterId="c666c9797ff14377b2a20749963e863c"
        customClassName={style.homeFloat}
        onLoad={this.onLoadHandler.bind(this)}
      />
    );
  }
}
